import { Button } from "nq-component";
import BaseListPage from "../../../../base/BaseListPage";
import Table from "../../../../components/Table";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import InputFactory from "../../../../components/InputFactory";
import AllowanceAssignTablePresenter from "./AllowanceAssignTablePresenter";

export default class AllowanceAssignTable extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AllowanceAssignTablePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      object: [],
      allowanceList: [],
      isMonthlyRate: false,
      isAmount: false,
      allowance: "",
      amount: "",
      excessAmount: "",
      taxable: "",
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const allowanceList = await findObjectUseCase().execute("allowance_type", {
      where: { status: "active" },
    });
    this.setState({ allowanceList });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.object !== this.state.object) {
      this.props.allowanceData(this.state.object);
    }
  }

  getCollectionName() {
    return "allowances";
  }

  async handleDeleteData(data) {
    console.log("data: ", data);
    this.setState((prevState) => {
      const updatedObject = prevState.object.filter(
        (item) => item.id !== data.id
      );
      // sessionStorage.setItem("allowanceObject", JSON.stringify(updatedObject));
      return { object: updatedObject };
    });
  }

  handleObjectData(data) {
    this.setState({
      objectID: data.id,
      selectedAllowance: data.allowance,
      amount: data.amount,
      taxable: data.taxable,
      isAmount: data.isAmount,
      isMonthlyRate: data.isMonthlyRate,
      excessAmount: data.excessAmount,
      selectedTax: data.selectedTax,
    });
  }

  async refetchData() {
    this.setState({
      objectID: "",
      selectedAllowance: "",
      amount: "",
      taxable: "",
      excessAmount: "",
    });
  }

  handleChangeForm(field, value) {
    if (field === "allowanceObj") {
      this.setState({
        // amount: value.amount,
        allowance: value.AllowanceType,
        // taxable: value.taxable,
        // excessAmount: value.excessAmount,
      });
    } else {
      this.setState({ [field]: value });
    }
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  handleCheckBox(field) {
    this.setState((prevState) => {
      const newState = {
        isMonthlyRate:
          field === "isMonthlyRate" ? !prevState.isMonthlyRate : false,
        isAmount: field === "isAmount" ? !prevState.isAmount : false,
      };

      this.setState({
        amount: newState.isMonthlyRate ? "" : this.state.amount,
      });

      return newState;
    });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const {
      object,
      isMonthlyRate,
      isAmount,
      allowance,
      allowanceList,
      amount,
      excessAmount,
      taxable,
      count,
      limit,
      current,
    } = this.state;

    if (object.length > 0) {
      sessionStorage.setItem("allowanceObject", JSON.stringify(object));
    }
    return (
      <>
        <div className="d-flex gap-2 align-items-center mb-4 mt-4">
          <SearchSelect
            value={allowance}
            onChange={(value) => this.handleChangeForm("allowanceObj", value)}
            onClickClear={(value) => this.handleChangeForm("allowanceObj", "")}
            options={allowanceList.map((allowance) => ({
              label: allowance.AllowanceType,
              value: allowance,
            }))}
          />
          <div className="d-flex gap-2 justify-content-center">
            <label
              style={{ display: "flex", alignItems: "center", gap: "4px" }}
            >
              <input
                style={{ accentColor: "#0038A8" }}
                type="checkbox"
                onChange={() => this.handleCheckBox("isMonthlyRate")}
                checked={isMonthlyRate}
                name="isMonthlyRate"
              />
              <span>Monthly_rate</span>
            </label>

            <label
              style={{ display: "flex", alignItems: "center", gap: "4px" }}
            >
              <input
                style={{ accentColor: "#0038A8" }}
                type="checkbox"
                onChange={() => this.handleCheckBox("isAmount")}
                checked={isAmount}
                name="isAmount"
              />
              <span>Amount</span>
            </label>
          </div>
          {isAmount && (
            <>
              <div className="d-flex gap-2">
                <InputFactory
                  type="Number"
                  // _type="parseNumber"
                  placeholder="Enter Amount"
                  field={"amount"}
                  value={amount}
                  onChange={(value) => this.handleChangeForm("amount", value)}
                />
                <SearchSelect
                  value={taxable}
                  onClickClear={() => {
                    this.hanldeTaxChange("");
                  }}
                  onChange={(value) => this.handleChangeForm("taxable", value)}
                  options={["YES", "NO"].map((type) => ({
                    label: type,
                    value: type,
                  }))}
                  placeholder="Maximum-Non Taxable"
                />
              </div>
            </>
          )}

          {this.state.taxable === "YES" && (
            <div>
              <InputFactory
                type="Number"
                field="excessAmount"
                placeholder="Enter Amount"
                value={excessAmount || ""}
                onChange={(value) =>
                  this.handleChangeForm("excessAmount", value)
                }
              />
            </div>
          )}

          <Button
            className="btn btn-primary"
            disabled={!allowance}
            onClick={this.presenter.handleSaveClick}
          >
            Save
          </Button>
        </div>
        <Table
          objectId={this.handleDeleteData.bind(this)}
          refetch={this.refetchData.bind(this)}
          objectData={this.handleObjectData.bind(this)}
          fields={schema.fields}
          objects={object}
          collection={schema}
          count={count}
          limit={limit}
          current={current}
          loadPagination={this.onClickPagination.bind(this)}
          actionsList={[
            {
              label: <i className="bi bi-pencil-square" />,
              actionType: "object",
            },
            {
              label: <i className="bi bi-trash" />,
              actionType: "delete",
            },
          ]}
          excludeFields={Object.keys(schema.fields).reduce(
            (acc, key) => {
              const options = schema.fields[key];
              if (options.read === false) {
                acc.push(key);
              }
              switch (options._type || options.type) {
                case "Relation":
                case "Array":
                case "Object":
                case "File":
                  acc.push(key);
                  break;
                default:
              }
              return acc;
            },
            ["id", "Created At", "Updated At"]
          )}
          onClickItem={this.onClickItem.bind(this)}
        />
      </>
    );
  }
}
